import React, { FC, Fragment } from 'react';

import * as CSS from '../../match-entry-styles';
import { Course, Player, Match, Round, PlayerResult } from '../../../../../database.schema';
import { calculateScore } from '../../../../utils/score-calculator';
import { MatchResult } from './match-result';
import { BACK_NINE_INDEX, FRONT_NINE_INDEX } from '../../../../app/constants';
import { useFetchPlayers } from '../../../../api/hooks/use-fetch-players';

type ConfirmationProps = {
  startingHole: number;
  holeIndex: number;
  course: Course;
  recordedMatch: Match;
  setShowConfirm: (value: boolean) => void;
  setShowScoreEntry: (value: boolean) => void;
  decrementHole: () => void;
};
export const Confirmation: FC<ConfirmationProps> = ({ startingHole, holeIndex, course, recordedMatch, setShowConfirm, setShowScoreEntry, decrementHole }): JSX.Element => {
  const holeIndexes = startingHole === 1 ? [...FRONT_NINE_INDEX, ...BACK_NINE_INDEX] : [...BACK_NINE_INDEX, ...FRONT_NINE_INDEX];
  const { data } = useFetchPlayers();
  const players = data as Array<Player>;
  const getPar = () => {
    if (holeIndex === 9) {
      if (startingHole === 1) {
        return course.scoreCard.slice(0, 9).reduce((accumulator, currentHole) => accumulator + currentHole, 0);
      } else {
        return course.scoreCard.slice(9).reduce((accumulator, currentHole) => accumulator + currentHole, 0);
      }
    } else {
      if (startingHole === 1) {
        return course.scoreCard.slice(9).reduce((accumulator, currentHole) => accumulator + currentHole, 0);
      } else {
        return course.scoreCard.slice(0, 9).reduce((accumulator, currentHole) => accumulator + currentHole, 0);
      }
    }
  };
  const getPlayerScore = (scoreCard: Array<number>) => {
    if (holeIndex === 9) {
      return scoreCard.slice(0, 9).reduce((accumulator, currentHole) => accumulator + currentHole, 0);
    } else {
      return scoreCard.slice(9).reduce((accumulator, currentHole) => accumulator + currentHole, 0);
    }
  };
  const getPlayerPoints = (player: Round | undefined) => {
    if (!player) {
      return 0;
    }
    if (holeIndex === 9) {
      return player?.scoreCard.slice(0, 9).reduce(
        (accumulator, currentHole, index) =>
          accumulator +
          calculateScore({
            score: currentHole,
            handicap: player.individualHandicap,
            par: course.scoreCard[holeIndexes[index]],
            strokeIndex: course.strokeIndex[holeIndexes[index]],
          }),
        0,
      );
    } else {
      return player.scoreCard.slice(9).reduce(
        (accumulator, currentHole, index) =>
          accumulator +
          calculateScore({
            score: currentHole,
            handicap: player.individualHandicap,
            par: course.scoreCard[holeIndexes[index + 9]],
            strokeIndex: course.strokeIndex[holeIndexes[index + 9]],
          }),
        0,
      );
    }
  };
  return (
    <Fragment>
      <h2>Score Entry: Confirmation</h2>
      <h3>Course: {course.name}</h3>
      <CSS.ScoreEntryWrapper>
        <CSS.MiddleSection>
          <CSS.ConfirmationHeader>
            {holeIndex <= 9 && <div>Front 9 Par: {getPar()}</div>}
            {holeIndex > 9 && <div>Back 9 Par: {getPar()}</div>}
          </CSS.ConfirmationHeader>
          <CSS.FlexRow>
            <CSS.ConfirmationData>Player</CSS.ConfirmationData>
            <CSS.ConfirmationData>Score</CSS.ConfirmationData>
            <CSS.ConfirmationData>Points</CSS.ConfirmationData>
          </CSS.FlexRow>
          <CSS.FlexColumn data-testid="course-and-handicap" style={{ border: '2px solid red', background: 'red', color: 'white', borderRadius: '5px', padding: '0.5rem 0' }}>
            {recordedMatch.team1.players.map((playerResult: PlayerResult, index: number) => (
              <CSS.FlexRow key={`t1-${index}`}>
                <CSS.ConfirmationData>{players.find((player: Player) => player.id === playerResult.playerId)?.nickName}</CSS.ConfirmationData>
                <CSS.ConfirmationData>{getPlayerScore(playerResult.round.scoreCard)}</CSS.ConfirmationData>
                <CSS.ConfirmationData>{getPlayerPoints(playerResult?.round)}</CSS.ConfirmationData>
              </CSS.FlexRow>
            ))}
          </CSS.FlexColumn>
          <MatchResult holeIndex={holeIndex} resultByHole={recordedMatch.resultByHole} />
          <CSS.FlexColumn
            data-testid="course-and-handicap"
            style={{ border: '2px solid blue', background: 'blue', color: 'white', borderRadius: '5px', margin: ' 0 0 1rem', padding: '0.5rem 0' }}
          >
            {recordedMatch.team2.players.map((playerResult: PlayerResult, index: number) => (
              <CSS.FlexRow key={`t2-${index}`}>
                <CSS.ConfirmationData>{players.find((player: Player) => player.id === playerResult.playerId)?.nickName}</CSS.ConfirmationData>
                <CSS.ConfirmationData>{getPlayerScore(playerResult.round.scoreCard)}</CSS.ConfirmationData>
                <CSS.ConfirmationData>{getPlayerPoints(playerResult?.round)}</CSS.ConfirmationData>
              </CSS.FlexRow>
            ))}
          </CSS.FlexColumn>
          <CSS.NavigationWrapper>
            <CSS.FlexRow>
              <CSS.NavigationButton
                onClick={() => {
                  if (holeIndex <= 9) {
                    decrementHole();
                  }
                  setShowConfirm(false);
                }}
              >
                Back
              </CSS.NavigationButton>
              {holeIndex < 17 && (
                <CSS.NavigationButton
                  data-testid="confirm-button"
                  onClick={() => {
                    setShowConfirm(false);
                  }}
                >
                  Confirm
                </CSS.NavigationButton>
              )}
              {holeIndex === 17 && (
                <CSS.ConfirmationData>
                  <CSS.NavigationButton data-testid="confirm-button" onClick={() => setShowScoreEntry(false)}>
                    Confirm
                  </CSS.NavigationButton>
                </CSS.ConfirmationData>
              )}
            </CSS.FlexRow>
          </CSS.NavigationWrapper>
        </CSS.MiddleSection>
      </CSS.ScoreEntryWrapper>
    </Fragment>
  );
};
